import * as types from "../actionTypes";

export const setProfitAndLossMainByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_PROFIT_AND_LOSS_MAIN_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setProfitAndLossMainByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_PROFIT_AND_LOSS_MAIN_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceProfitAndLossMainYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_PROFIT_AND_LOSS_MAIN_YEARS,
      key,
      payload,
    });
  };
};

export const resetProfitAndLossMainReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_PROFIT_AND_LOSS_MAIN_REDUCER,
    });
  };
};
